class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.readmore = this.querySelector(".readmore");
    this.readmore.addEventListener("click", (e) => {
      e.preventDefault();
      this.querySelector(".readmore-content").classList.add("show");
      this.readmore.remove();
    });
    this.email = this.querySelector(".email-field");
    this.email.focus();
    "change,blur,focus,paste".split(",").forEach((x) => {
      this.email.addEventListener(x, this.validate);
    });
    this.error = this.querySelector(".error-message");
    this.querySelector(".close-container button").addEventListener(
      "click",
      () => {
        this.close();
      }
    );
    this.querySelector("form").addEventListener("submit", this.onsubmit);
    if (!this.isClosed) {
      setTimeout(() => {
        this.classList.add("show");
      }, 2500);
    }
  }
  get isClosed() {
    return localStorage.getItem("MODAL_CLOSED") === "true";
  }
  set isClosed(val) {
    localStorage.setItem("MODAL_CLOSED", val);
  }
  validate = () => {
    if (this.email.value === "") {
      this.email.classList.add("error");
      this.error.innerHTML = this.email.dataset.empty;
      return false;
    }
    const isValid = this.email.value
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
    if (isValid) {
      this.email.classList.remove("error");
      this.error.innerHTML = "";
      return true;
    } else {
      this.email.classList.add("error");
      this.error.innerHTML = this.email.dataset.invalid;
      return false;
    }
  };
  close = () => {
    this.isClosed = "true";
    this.classList.remove("show");
  };
  onsubmit = (e) => {
    e.preventDefault();
    if (!this.validate()) return;
    const myForm = e.target;
    const formData = new FormData(myForm);

    fetch(myForm.action, {
      method: "POST",
      body: formData,
    })
      .then((res) => {
        if (res.url.includes("challenge") && res.redirected)
          window.location = res.url;
        else if (res.ok) {
          this.querySelector(".form-response").classList.add("form-posted");
        }
      })
      .catch((error) => alert(error));
  };
}

customElements.define("newsletter-popup", NewsletterPopup);
